import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import _ from 'lodash';
import { setRoleAndSubRoles } from './role';
import { logout, onForbidden } from './login';
import { StorageApi } from '../../utils/storageApi';

//- Actions
export const fetchGetUserDataByTokenFailed = createAction('FETCH_GET_USER_DATA_BY_TOKEN_FAILED');
export const fetchGetUserDataByTokenSuccess = createAction('FETCH_GET_USER_DATA_BY_TOKEN_SUCCESS');
export const fetchGetUserDataByToken = createAction(
    'FETCH_GET_USER_DATA_BY_TOKEN',
    (token) => Api.getUserDataByToken(token),
    () => ({
        apiCall: true,
        onSuccess: fetchGetUserDataByTokenSuccess,
        onFail: fetchGetUserDataByTokenFailed
    })
);

export const fetchGetUserDataFailed = createAction('FETCH_GET_USER_DATA_FAILED');
export const fetchGetUserDataSuccess = createAction('FETCH_GET_USER_DATA_SUCCESS');
export const onGetUserDataSuccess = (data) => (dispatch) => {
    StorageApi.setUserId(data.id);
    dispatch(setRoleAndSubRoles(data.role, data.subRoles));
    dispatch(fetchGetUserDataSuccess(data));
};
export const fetchGetUserData = createAction(
    'FETCH_GET_USER_DATA',
    () => Api.getUserData(),
    () => ({
        apiCall: true,
        onSuccess: onGetUserDataSuccess,
        onFail: fetchGetUserDataFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);


//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
    fetchingByToken: false
};

//- Reducers
export default handleActions({

    FETCH_GET_USER_DATA: (state) => {
        return { ...state, data: null, error: null, fetching: true };
    },
    FETCH_GET_USER_DATA_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_USER_DATA_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    },
    FETCH_GET_USER_DATA_BY_TOKEN: (state) => {
        return { ...state, data: null, error: null, fetchingByToken: true };
    },
    FETCH_GET_USER_DATA_BY_TOKEN_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetchingByToken: false };
    },
    FETCH_GET_USER_DATA_BY_TOKEN_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetchingByToken: false };
    }

}, initialState);

//- Selectors
export const getUser = state => state.userData;

export const getUserData = state => getUser(state).data;

export const isLoading = state => getUser(state).fetching;

export const getLoadingDataByToken = state => getUser(state).fetchingByToken;

export const getUserDataError = state => getUser(state).error;

export const getUserEmail = state => {
    let data = getUserData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.email;
}

export const getUserIdentityAlias = state => {
    let data = getUserData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.identityAlias;
}

export const getUserRole = state => {
    let data = getUserData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.role;
}

export const getUserId = state => {
    let data = getUserData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.id;
}

export const getUserSecret = state => {
    let data = getUserData(state);

    if (_.isNil(data)) {
        return null;
    }

    return data.browserSecret;
}


export const getUserPersonalData = state => {
    return {
        email: getUserEmail(state),
        ...getUserIdentityAlias(state)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/account/userData.js